import { HotKeys } from "./hotkeys.js"
const hotKeys = new HotKeys()